import React, { useState, useEffect } from "react";

// Normalize path to ensure it starts with /
const normalizePath = (path) => {
  if (!path) return '/images/defaultIcon.svg';
  // If path already starts with / or http, return as is
  if (path.startsWith('/') || path.startsWith('http')) return path;
  // Add leading slash
  return `/${path}`;
};

const Assets = ({ src, alt = "img", fallbackSrc = '/images/defaultIcon.svg', ...props }) => {
  const normalizedSrc = normalizePath(src);
  const normalizedFallback = normalizePath(fallbackSrc);
  
  const [imgSrc, setImgSrc] = useState(normalizedSrc);
  const [hasError, setHasError] = useState(false);

  const handleError = () => {
    if (!hasError) {
      setHasError(true);
      setImgSrc(normalizedFallback);
    }
  };

  // Reset error state when src changes
  useEffect(() => {
    const newSrc = normalizePath(src);
    setImgSrc(newSrc);
    setHasError(false);
  }, [src]);

  return (
    <img
      {...props}
      src={imgSrc}
      alt={alt}
      onError={handleError}
    />
  );
};

export default Assets;

